/* eslint-disable import/prefer-default-export */
import Types from '../../modules/types';

export const tests = Types.ONBOARDING_STEPS_ITEMS.reduce(
  (agr, { id }) => {
    ['===', '!=='].forEach(op => {
      agr[[
        'skipIfStep',
        op === '===' ? '' : 'Not',
        `${id.slice(0, 1)}${id.slice(1).toLowerCase()}`,
      ].join('')] = [
        'condition.testFieldValue',
        'onboarding.currentStep',
        op,
        id,
      ];
    });
    return agr;
  },
  {},
);
